import {Select, ISelect} from "./";
import { getSpecialties } from "../../../apis/public.api";
import { useEffect, useState } from "react";
import { textChooser } from "../../../util/textChooser";
import { formatValuesForSelect } from "../../../helpers/utilities";

interface SpecialtiesProps extends ISelect {}

export const Specialties = (props: SpecialtiesProps) => {

    const [specialties, setSpecialties] = useState([]);

    useEffect(() => {
        getSpecialties().then((specialtiesData) => {
            formatValuesForSelect(setSpecialties, specialtiesData)
        })
    },[])

    return(
        <Select 
            {...props} 
            label={props?.label ?? textChooser("txt113")}
            values={specialties} 
            currentValue={props.currentValue} 
        />
    )
}